import { useMemo } from 'react';
import { ROLE_HINTS } from '../../utils/roles';

const LEVELS = {
  full: { label: 'Full', tone: 'success' },
  partial: { label: 'Partial', tone: 'warning' },
  none: { label: 'No access', tone: 'default' }
};

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export function buildMatrix({ permissions = [], presets = {} } = {}) {
  const roles = Object.keys(presets).map((key) => ({ key, label: capitalize(key), hint: ROLE_HINTS[key] }));
  const groups = [...new Set(permissions.map((p) => p.group))];
  const sections = groups.map((group) => {
    const items = permissions.filter((p) => p.group === group);
    const access = Object.fromEntries(
      roles.map(({ key }) => {
        const granted = items.filter((p) => presets[key].includes(p.key)).length;
        const level = granted === items.length ? 'full' : granted ? 'partial' : 'none';
        return [key, { granted, total: items.length, ...LEVELS[level] }];
      })
    );
    return { group, items, access };
  });
  return { roles, sections };
}

export function usePermissionMatrix(data) {
  return useMemo(() => buildMatrix(data), [data]);
}
